var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5352 9.34743C13.9258 8.95691 13.9258 8.32374 13.5352 7.93322C13.1447 7.54269 12.5115 7.54269 12.121 7.93322L9.99972 10.0545L7.8784 7.93319C7.48788 7.54267 6.85471 7.54267 6.46419 7.93319C6.07367 8.32371 6.07367 8.95688 6.46419 9.3474L9.28646 12.1697C9.2885 12.1717 9.29054 12.1738 9.29259 12.1759C9.6343 12.5176 10.1618 12.5603 10.5499 12.304C10.6054 12.2674 10.658 12.2247 10.7068 12.1759C10.7068 12.1758 10.7068 12.1758 10.7068 12.1758C10.7071 12.1756 10.7074 12.1753 10.7077 12.175L13.5352 9.34743Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.f2cfda8e5a3c9dda1e2ed432a2763473.svg";
export { ForwardRef as ReactComponent };